import { MarkdownContentSize } from '@backrs_ui/common-ui/src/molecules/Markdown/markdownComponents';

import { Box, SxProps, Theme } from '@mui/material';

type QuizFigureProps = Readonly<{
  /** Null on the text-only questions and options that are the norm. */
  url: string | null;
  /** Matches the scale of the text it sits with. */
  size: MarkdownContentSize;
  alt: string;
}>;

/**
 * A quiz figure: an option's diagram, a question's diagram, or a passage's stimulus.
 * One size treatment for all three — the alt text is what differs, so callers supply it.
 */
export const QuizFigure = ({ url, size, alt }: QuizFigureProps) => {
  if (!url) return null;

  return <Box component="img" src={url} alt={alt} loading="lazy" sx={figureSx(size)} />;
};

const figureSx =
  (size: MarkdownContentSize): SxProps<Theme> =>
  ({ backrs }) => ({
    display: 'block',
    maxWidth: '100%',
    maxHeight: size === 'SMALL' ? '160px' : '240px',
    height: 'auto',
    objectFit: 'contain',
    marginTop: backrs.spacing['spacing-md'],
    borderRadius: backrs.radius['radius-md'],
  });
